<template>
  <v-btn
    depressed
    large
    class="ma-2 right d-print-none"
    :disabled="!hasMoreResults"
    :loading="loading"
    @click="() => $emit('loadMore')"
    ><v-icon color="secondary" small left>{{
      hasMoreResults ? "$iconDownload" : "$iconTimesCircle"
    }}</v-icon
    >{{ $t("common:loadMore.button") }}</v-btn
  >
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "AppLoadMoreBtn",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    hasMoreResults: {
      type: Boolean,
      required: true
    }
  },
  emits: ["loadMore"]
});
</script>
